import { apiPost } from './client';
import { getTVCampaign } from '../utils/analytics';
import { getOrCreateTvSurveyResponseId } from '../utils/tvSurveyIdentity';

export async function submitTvSurvey(payload = {}) {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const environment = host.endsWith('.vercel.app') || host === 'localhost' || host === '127.0.0.1'
    ? 'develop'
    : 'production';

  const campaign = payload.campaign != null && payload.campaign !== ''
    ? payload.campaign
    : getTVCampaign();

  // 第1回・第2回で同一 ID を再利用（送信失敗の再試行でも再発行しない）
  const tv_response_id = payload.tv_response_id
    || getOrCreateTvSurveyResponseId(campaign);

  return apiPost('/api/tv-survey', {
    ...payload,
    campaign,
    host,
    path,
    environment,
    tv_response_id,
  });
}
